import { lodestarColors, ursaColors } from "@smartsheet/design-tokens";
import { themed } from "../../../util/theme";

export const formLabelColorTheme = themed({
    color: {
        error: {
            "lodestar-light": lodestarColors.danger,
            "ursa-light": ursaColors.red600,
        },
        success: {
            "lodestar-light": lodestarColors.success,
            "ursa-light": ursaColors.mint600,
        },
        warn: {
            "lodestar-light": lodestarColors.warning,
            "ursa-light": ursaColors.gold800,
        },
        info: {
            "lodestar-light": lodestarColors.neutralDark20,
            "ursa-light": ursaColors.neutral600,
        },
        waiting: {
            "lodestar-light": lodestarColors.neutralDark20,
            "ursa-light": ursaColors.neutral600,
        },
    },
});

export const descriptionVariantProps = {
    oldestar: {
        system: "lodestar",
        variant: "bodyText",
    },
    "lodestar-light": {
        system: "lodestar",
        variant: "bodyText",
    },
    "ursa-light": {
        system: "ursa",
        variant: "Inter--12px--400w",
    },
} as const;
